import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Theme } from './Theme'
import type { GETThemesResponseType } from '../infrastructure/HTTPPropertyRepository/schemas/themes'

export const ListOfThemeValidation = z.object({
  list: z.instanceof(Theme, { message: '[ListOfTheme] list is required' }).array(),
})

export class ListOfTheme extends Model {
  static readonly MAX_FEATURED = 5

  static create({ list }: z.infer<typeof ListOfThemeValidation>) {
    ListOfThemeValidation.parse({ list })
    return new ListOfTheme(list)
  }

  static fromAPI({ json }: { json: GETThemesResponseType }) {
    return ListOfTheme.create({
      list: json.themes.map(themeJSON => Theme.fromAPI({ json: themeJSON })),
    })
  }

  static fromJSON({ json }: { json: ReturnType<ListOfTheme['toJSON']> }) {
    return ListOfTheme.create({
      list: json.list.map(themeJSON => Theme.fromJSON({ json: themeJSON })),
    })
  }

  static empty() {
    return new ListOfTheme([])
  }

  constructor(private readonly _list: Theme[]) {
    super()
  }

  get list() {
    return this._list
  }

  get length() {
    return this._list.length
  }

  getFeatured() {
    return this._list.slice(0, ListOfTheme.MAX_FEATURED)
  }

  getNonFeatured() {
    return this._list.slice(ListOfTheme.MAX_FEATURED)
  }

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  isEmpty() {
    return this._list.length === 0
  }

  at(index: number) {
    return this._list.at(index)
  }

  map<T>(callback: (theme: Theme, index: number) => T) {
    return this._list.map(callback)
  }
}
